<template>
  <div>
    <a-modal v-model="visible" width="660px" :mask-closable="false" title="添加服务" ok-text="确认" cancel-text="取消" :ok-button-props="{ props: { loading: loading, disabled: disabled } }" @ok="submit" @cancel="close">
      <a-spin :spinning="spinning">
        <a-form-model ref="modalForm" :keyboard="false" :model="modalForm" :rules="rules" :label-col="labelCol">
          <a-form-model-item label="服务名称" prop="service_id" :wrapper-col="wrapperCol">
            <a-select v-model="modalForm.service_id" show-search placeholder="请选择服务" :filter-option="filterOption" @change="onChangeService">
              <a-select-option v-for="service in servicesData" :key="service.service_id" :value="service.service_id" :disabled="selectedServices.includes(service.service_id)">
                {{ service.service_name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item v-if="[1, 2].includes(modalForm.service_type)" label="制品版本" prop="artifact_version_id" :wrapper-col="wrapperCol">
            <a-select v-model="modalForm.artifact_version_id" show-search :disabled="modalForm.service_id === null" placeholder="请选择制品版本" :filter-option="filterOption" @change="onChangeVersion">
              <a-select-option v-for="item in artifactVersionData" :key="item.id" :value="item.id" :disabled="item.bound">{{ `${item.version}(${item.git_tag_name})` }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item v-else label="制品版本" prop="artifact_version_id" :wrapper-col="wrapperCol">
            <a-select v-model="modalForm.artifact_version_id" show-search :disabled="modalForm.service_id === null" :filter-option="filterOption" @change="onChangeVersion">
              <a-select-option v-for="item in versionData" :key="item.version_id" :value="item.version_id">{{ item.build_version }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="开发人员" prop="developers" :wrapper-col="wrapperCol">
            <user-select v-model="modalForm.developers" role="DEV" :project-id="projectId" placeholder="请选择开发人员" />
          </a-form-model-item>
          <a-form-model-item v-if="[1].includes(modalForm.service_type)" label="数据变更" prop="data_change" :wrapper-col="wrapperCol" extra="提示：如无数据变更请勾选[无数据变更]，如果有请选择对应类型">
            <a-checkbox-group v-model="modalForm.data_change">
              <a-row style="margin-top: 8px">
                <a-col v-for="(item, index) in dataChangeOptions" :key="index" :span="8" style="line-height: 24px">
                  <a-checkbox v-if="item.value === 'no_change'" value="no_change" @change="onNoChangeCheck">{{ item.label }}</a-checkbox>
                  <a-checkbox v-else :value="item.value" :disabled="modalForm.data_change.includes('no_change')">{{ item.label }}</a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>
          </a-form-model-item>
          <a-form-model-item v-if="configData.length !== 0" label="需修改的配置项" :wrapper-col="wrapperCol">
            <a-select v-model="modalForm.configs" mode="multiple" show-search :filter-option="filterOption" placeholder="请选择需要修改的配置项(非必填)">
              <a-select-option v-for="(item, index) in configData" :key="index" :value="item">{{ item }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item v-if="[1].includes(modalForm.service_type) && canUseGrayDep" class="testplan-form-item" label="内灰计划">
            <a-select v-model="modalForm.grayTemp" style="width: 400px" :disabled="!canEditGrayTemp" allow-clear placeholder="请选择灰度模版" show-search :filter-option="utils.filterOption">
              <template v-for="(template, index) in grayServiceSelection">
                <a-select-option v-if="template.ruleType === 'condition'" :key="index" :value="template.templateId">{{ template.templateName }}</a-select-option>
              </template>
            </a-select>
          </a-form-model-item>
          <a-form-model-item v-if="[1].includes(modalForm.service_type) && canUseGrayDep" class="testplan-form-item" label="外灰计划">
            <a-select v-model="modalForm.grayPercent" style="width: 400px" allow-clear placeholder="请选择灰度模版" show-search :filter-option="utils.filterOption">
              <template v-for="(template, index) in grayServiceSelection">
                <a-select-option v-if="template.ruleType === 'weight'" :key="index" :value="template.weight">{{ template.templateName }}</a-select-option>
              </template>
            </a-select>
          </a-form-model-item>
        </a-form-model>
        <a-alert v-if="!hasNewConfig && filterForm.service_id !== null" :message="message" type="warning" show-icon />
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { dataChangeOptions } from '@/utils/dictionary';
import { queryConfigKeys } from '@/api/project/workflow';
import { applicationVersions } from '@/api/tools/application';
import { serviceArtifactVersion, grayTempList } from '@/api/project/workflow';

import UserSelect from '@/pages/project/components/UserSelect';

export default {
  components: { UserSelect },
  props: {
    users: {
      type: Object,
      default: () => {
        return {};
      }
    },
    servicesData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    templateId: {
      type: Number,
      default: null
    },
    isShow: {
      type: Boolean,
      default: false
    },
    modifyIndex: {
      type: [String, Number],
      default: null
    },
    modifyService: {
      type: Object,
      default: () => {
        return {};
      }
    },
    selectedServices: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      loading: false,
      spinning: false,
      hasNewConfig: true,
      canUseGrayDep: false,
      grayServiceSelection: [],
      canEditGrayTemp: true,
      dataChangeOptions,
      versionLoading: false,
      visible: this.isShow,
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      artifactVersionData: [],
      versionData: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      releaseId: parseInt(this.$route.query.releaseId) || null,
      workflowId: parseInt(this.$route.query.workflowId) || null,
      modalForm: {
        service_id: null,
        can_use_gray: 0,
        images: null,
        grayTemp: '',
        artifact_id: null,
        artifact_version_id: null,
        artifact_version: null,
        service_type: null,
        developers: [],
        configs: [],
        data_change: []
      },
      filterForm: {
        service_id: null,
        artifact_id: null,
        version: null,
        page_number: 1,
        page_size: null
      },
      configData: [],
      rules: {
        service_id: [{ required: true, message: '服务不能为空', trigger: 'blur' }],
        artifact_version_id: [{ required: true, message: '制品版本不能为空', trigger: 'blur' }],
        image: [{ required: true, message: '制品版本不能为空', trigger: 'blur' }],
        developers: [{ required: true, message: '开发人员不能为空', trigger: 'blur' }],
        data_change: [{ required: true, message: '请选择是否有数据变更', trigger: 'change' }]
      },
      message: '当前服务不符合自动发布新规范，不允许提审，请联系运维同学处理！'
    };
  },
  computed: {
    disabled() {
      return this.hasNewConfig === false || this.filterForm.service_id === null;
    }
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true && this.modifyIndex !== null) {
        this.modalForm = JSON.parse(JSON.stringify(this.modifyService));
        this.filterForm.service_id = this.modalForm.service_id;
        this.spinning = true;
        if ([3, 4].includes(this.modalForm.service_type)) {
          this.getAppliactionVersions();
        } else {
          this.getArtifactVersionList();
          this.canUseGrayDep = true;
        }
        this.getConfigKeys();
        this.spinning = false;
      } else {
        this.modalForm = {
          service_id: null,
          service_name: null,
          images: null,
          can_use_gray: 0,
          grayTemp: '',
          artifact_id: null,
          artifact_version_id: null,
          artifact_version: null,
          service_type: null,
          developers: [],
          configs: [],
          data_change: []
        };
      }
    }
  },
  mounted() {
    this.getGrayService();
  },

  methods: {
    /**
     * 关闭模态框事件
     */
    close() {
      this.$refs.modalForm.resetFields();
      this.$emit('close');
    },
    getGrayService() {
      grayTempList({}).then(res => {
        this.grayServiceSelection = res.data;
      });
    },
    /**
     * 服务变化时的回调
     * @param {*} value
     * @param {*} option
     */
    onChangeService(value, option) {
      this.spinning = true;
      const service = this.servicesData[value];
      this.modalForm.service_type = service.service_type.value;
      this.modalForm.artifact_id = service.artifact_id;
      this.filterForm.service_id = this.modalForm.service_id;
      this.modalForm.can_use_gray = service.can_use_gray;
      this.modalForm.artifact_version_id = null;
      this.modalForm.artifact_version = null;
      this.modalForm.configs = [];
      if ([3, 4].includes(this.modalForm.service_type)) {
        this.getAppliactionVersions(this.modalForm.artifact_version);
      } else {
        this.getArtifactVersionList();
      }
      this.getConfigKeys();
    },

    /**
     * 版本变化时的回调
     * @param {*} value
     * @param {*} option
     */
    onChangeVersion(value, option) {
      this.modalForm.artifact_version = option.componentOptions.children[0].text;
    },

    /**
     * 获取制品版本列表
     */
    getArtifactVersionList() {
      this.versionLoading = true;
      this.artifactVersionData = [];
      serviceArtifactVersion({ service_id: this.filterForm.service_id, release_id: this.releaseId, workflow_id: this.workflowId }).then(res => {
        this.artifactVersionData = res.data.items;
        this.versionLoading = false;
      });
    },
    setDefaultGrayTemp() {
      const conditionTemplates = Array.isArray(this.grayServiceSelection) ? this.grayServiceSelection.filter(template => template.ruleType === 'condition') : [];
      if (conditionTemplates.length === 1 && this.canUseGrayDep === true) {
        this.modalForm.grayTemp = conditionTemplates[0].templateId;
        this.canEditGrayTemp = false; // 设置为不可编辑
      } else if (this.canUseGrayDep === false) {
        this.canEditGrayTemp = true;
        this.modalForm.grayTemp = '';
      }
    },

    /**
     * 获取APP版本列表
     * @param {*} value 版本号搜索value
     */
    getAppliactionVersions(value = null) {
      applicationVersions({ service_id: this.filterForm.service_id, build_version: value }).then(res => {
        this.versionData = res.data.items;
      });
    },

    /**
     * 点击提交
     */
    submit() {
      if (this.disabled) {
        this.$message.warning(this.message);
        return;
      }

      this.$refs.modalForm.validate(valid => {
        if (!valid) {
          return;
        }
        if ([1].includes(this.modalForm.service_type)) {
          if (!this.modalForm.data_change || this.modalForm.data_change.length === 0) {
            this.$message.error('请选择是否有数据变更');
            return;
          }
        }
        this.$emit('submitAddService', this.modalForm, this.modifyIndex);
      });
    },

    /**
     * 获取服务配置Keys列表
     */
    getConfigKeys() {
      this.configData = [];
      queryConfigKeys({ service_id: this.modalForm.service_id, template_id: this.templateId }).then(res => {
        this.configData = res.data.items;
        this.hasNewConfig = res.data.has_new_config;
        this.canUseGrayDep = res.data.can_use_gray;
        this.setDefaultGrayTemp();
        this.spinning = false;
      });
    },

    /**
     * 处理"无数据变更"选项的选择
     */
    onNoChangeCheck(e) {
      // 使用 $nextTick 确保在 DOM 更新后执行
      this.$nextTick(() => {
        if (e.target.checked) {
          this.$set(this.modalForm, 'data_change', ['no_change']);
        } else if (this.modalForm.data_change.includes('no_change')) {
          // 如果取消"无数据变更"，移除该选项
          this.modalForm.data_change = this.modalForm.data_change.filter(item => item !== 'no_change');
        }
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};
</script>
